<template>
  <br/>
  <div style="padding:5px"  class="row">
    <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
      <label for="search" class="form-label mt-2 me-2">Keyword</label>
      <input type="text" id="search" class="form-control" placeholder="Name, creator or id, Reference number" v-model="keyword"
             @input="getPayments"/>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
      <label for="type" class="form-label me-1 mt-2">Type</label>
      <select id="type" class="form-control" v-model="type" @change="getPayments">
        <option value="">All</option>
        <option value="1">One time-tips</option>
        <option value="2">Subscriptions</option>
        <option value="3">Pay per-post</option>
        <option value="4">Fundraiser</option>
        <option value="5">Merchant e-shop</option>
        <option value="6">Christmas donations</option>
        <option value="7">Pay per-category</option>
        <option value="8">Pay per-content subscription</option>
        <option value="9">Subscription upgrade</option>
        <option value="10">Gifts</option>
      </select>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
      <label for="per-page" class="form-label me-1 mt-2">Per page</label>
      <select id="per-page" class="form-control" v-model="perPage" @change="getPayments">
        <option :value="10">10</option>
        <option :value="20">20</option>
        <option :value="50">50</option>
      </select>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
      <label for="from-date" class="form-label mt-2 me-2">From date</label>
      <input type="datetime-local" id="from-date" class="form-control" placeholder="Name or creator" v-model="fromDate" @input="customDate"/>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
      <label for="to-date" class="form-label mt-2 me-2">To date</label>
      <div class="d-flex gap-1">
        <input type="datetime-local" id="to-date" class="form-control" v-model="toDate" @input="customDate"/>
        <button type="button" class="btn btn-dark-purple" @click="getPayments">
          <font-awesome-icon :icon="['fas', 'magnifying-glass']"/>
        </button>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
      <label for="provider-filter" class="form-label me-1 mt-2">Providers</label>
      <select id="provider-filter" class="form-control" v-model="provider" @change="getPayments">
        <option :value="null">All</option>
        <option v-for="(paymentProvider, index) in paymentProviders" :key="index" :value="paymentProvider.value">
          {{ paymentProvider.name }}
        </option>
      </select>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
      <label for="payment-status" class="form-label me-1 mt-2">Payment status</label>
      <select id="payment-status" class="form-control" v-model="status" @change="getPayments">
        <option :value="''">All</option>
        <option v-for="(paymentStatus, index) in paymentStatuses" :key="index" :value="paymentStatus.statuses">
          {{ paymentStatus.name }}
        </option>
      </select>
    </div>
    <div class="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-12 mb-3">
      <label class="form-label mt-2 me-2">Export creator payments</label>
      <button type="button" class="btn btn-success form-control" data-bs-target="#staticBackdrop"
           data-bs-toggle="modal" :disabled="disableExport">
        <span v-if="!disableExport">Export CSV</span>
        <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
      </button>
    </div>
    <div class="table-responsive container-fluid">
      <table class="table">
        <thead>
        <tr>
          <th scope="col"># ID</th>
          <th scope="col">Date</th>
          <th scope="col">Type</th>
          <th scope="col">Full name, email</th>
          <th scope="col">Creator</th>
          <th scope="col">Provider</th>
          <th scope="col">Reference number</th>
          <th scope="col">Amount</th>
          <th scope="col">Taxes</th>
          <th scope="col">Status</th>
          <th scope="col">Reason</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="loading">
          <td colspan="11" class="text-center"><font-awesome-icon icon="fa-solid fa-sync fa-10x" spin/></td>
        </tr>
        <tr v-else-if="payments.length > 0" v-for="(payment, index) in payments" :key="index">
          <th scope="row">{{ payment.id }}</th>
          <td>{{ payment.time }}</td>
          <td>{{ payment.type }}</td>
          <td>
            <p class="font-weight-bold">{{ payment.user.name }}</p>
            <a href="mailto:{{payment.user.email}}">{{ payment.user.email }}</a>
          </td>
          <td>
            <router-link v-if="payment.channel_id" :to="{name: 'SingleChannel',params: {id: payment.channel_id}}" target="_blank">
              {{payment.channel_name}}
            </router-link>
            <p v-else>-</p>
          </td>
          <td>
            {{ payment.provider }}
          </td>
          <td>
            <a v-if="payment.payment_link" :href="payment.payment_link" target="_blank">{{ payment.payment_number || 'Click here' }}</a>
            <p v-else>-</p>
          </td>
          <td>
            <p>{{ payment.cost }} {{ payment.currency }}</p>
            <p v-if="Array.isArray(payment.refund_data) && payment.refund_data.length > 0">
              <span class="text-danger">Refund: {{ getRefundAmount(payment.refund_data) }} {{ payment.currency }}</span>
            </p>
          </td>
          <td>
            <p>{{ payment.collected_fees }} {{ payment.currency }}</p>
          </td>
          <td>
            <p>{{ getPaymentStatusLabel(payment.status) }}</p>
          </td>
          <td>
            <p>{{ payment.cancellation_reason || '-' }}</p>
          </td>
        </tr>
        <tr v-else>
          <td colspan="11" class="text-center">No payments</td>
        </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
        <div>
          <div class="p-2">
            <p>Total payments: {{ totalRecords }}</p>
          </div>
        </div>
        <div>
          <div class="p-2">
            <nav v-if="totalPages >= 1" aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                  <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
                </li>
                <li class="page-item" :class="{active: 1 === currentPage}">
                  <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
                </li>
                <li class="page-item" v-if="currentPage - 2 > 1">
                  <a href="#" class="page-link">...</a>
                </li>
                <li class="page-item" v-if="currentPage - 2 > 1">
                  <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2 }}</a>
                </li>
                <li class="page-item" v-if="currentPage - 1 > 1">
                  <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1 }}</a>
                </li>
                <li class="page-item" v-if="currentPage !== 1" :class="{active: currentPage}">
                  <a @click="paginate(currentPage)" class="page-link"
                     :class="{'not-clickable': currentPage}">{{ currentPage }}</a>
                </li>
                <li class="page-item" v-if="currentPage + 1 <= totalPages">
                  <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1 }}</a>
                </li>
                <li class="page-item" v-if="currentPage + 2 <= totalPages">
                  <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2 }}</a>
                </li>
                <li class="page-item" v-if="currentPage + 2 < totalPages">
                  <a href="#" class="page-link">...</a>
                </li>
                <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages"
                    :class="{active: totalPages === currentPage}">
                  <a @click="paginate(totalPages)" class="page-link"
                     :class="{'not-clickable': totalPages === currentPage}">{{ totalPages }}</a>
                </li>
                <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                  <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">Creator extract form</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="name" class="form-label">Name</label>
            <input type="text" class="form-control me-1" id="name" v-model="name">
            <p v-if="validationErrors" v-for="errorName in validationErrors.name" class="text-danger">{{ errorName}}</p>
          </div>
          <p v-if="validationErrors" v-for="errorMonth in validationErrors.extract_month" class="text-danger">{{ errorMonth}}</p>
          <div class="mb-3">
            <label v-for="(checkbox, index) in checkboxes" :key="index"  class="label-checkbox container-checkbox inline-block">
              {{ checkbox.label }}
              <input type="checkbox" v-model="checkbox.checked" :value="checkbox.value">
            </label>
          </div>
          <div class="mb-3">
            <label v-for="(checkbox, index) in subscriptionCheckboxes" :key="index"  class="label-checkbox container-checkbox inline-block">
              {{ checkbox.label }}
              <input type="checkbox" v-model="checkbox.checked"  :value="checkbox.value">
            </label>
            <p v-if="validationErrors.checkbox" class="text-danger">{{ validationErrors.checkbox}}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="validateExportChannelPayments" type="button" class="btn btn-dark-purple" :disabled="disableExport">
            <span v-if="!disableExport">Export CSV</span>
            <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import _debounce from "lodash/debounce";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  components: {FontAwesomeIcon},
  data() {
    return {
      loading: true,
      disableExport: false,
      type: '',
      keyword: '',
      fromDate: '',
      toDate: '',
      name: '',
      payments: [],
      checkboxes: [
        { label: 'One-time tips', value: '1', checked: true },
        { label: 'Post sales', value: '3', checked: true },
        { label: 'Fund payments', value: '4', checked: true },
        { label: 'Merch sales', value: '5', checked: true },
        { label: 'Category sales', value: '7', checked: true },
        { label: 'PPC subscription', value: '8', checked: true },
        { label: 'Subscription tier update', value: '9', checked: true },
        { label: 'Gift sales', value: '10', checked: true },
      ],
      subscriptionCheckboxes: [
        { label: 'New subscriptions', value: '2', checked: true },
        { label: 'Recurring subscriptions', value: '1', checked: true },
      ],
      maxMonth: new Date().getFullYear() + '-' + new Date().getMonth() + 1,
      validationErrors: {},
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      perPage: 20,
      status: [1, 2, 4],
      paymentStatuses: [],
      provider: null,
      paymentProviders: []
    }
  },

  async mounted() {
    await this.getPaymentStatuses();
    this.getPaymentProviders();
    this.getPayments();
  },

  computed: {
    getPaymentStatusLabel() {
      return (status) => {
        const statusMap = {
          0: 'Abandoned',
          1: 'Recurring',
          2: 'New',
          3: 'Failed',
          4: 'Canceled / Refunded'
        };
        return statusMap[status] || 'Undefined';
      };
    }
  },

  methods: {
    debounceGetPayments: _debounce(function (keyword, fromDate, toDate, type, page, perPage, status, provider) {
      this.loading = true;

      const params = {
        keyword,
        type,
        from_date: fromDate,
        to_date: toDate,
        page,
        per_page: perPage,
        status,
        provider
      };

      // Remove null/undefined/empty string values
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === undefined || params[key] === '') {
          delete params[key];
        }
      });

      axios.get('/admin/payments', { params })
      .then(response => {
        this.payments = response.data.data;
        this.totalPages = response.data.totalPages;
        this.totalRecords = response.data.totalRecords;
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
        this.loading = false;
      });
    }, 500),
    getPayments() {
      this.loading = true;
      this.debounceGetPayments(this.keyword, this.fromDate, this.toDate,  this.type, this.currentPage, this.perPage, this.status, this.provider);
    },
    validateExportChannelPayments() {
      this.validationErrors = {};
      this.disableExport = true;
      const checkedValue = this.checkboxes.filter(checkboxes => checkboxes.checked).map(checkbox => checkbox.value);
      const subscriptionCheckedValue = this.subscriptionCheckboxes
          .filter(subscriptionCheckboxes => subscriptionCheckboxes.checked)
          .map(subscriptionCheckboxes => subscriptionCheckboxes.value);
      axios.post(`/admin/export/channel-payments`, {
        'name': this.name,
        'checkboxes': checkedValue,
        'subscriptionCheckboxes': subscriptionCheckedValue,
        'extract_from_date' : this.fromDate,
        'extract_to_date' : this.toDate
      }, {
        responseType: 'blob'
      })
      .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' });
          const now = new Date();
          const readableTime = now.toISOString().replace(/[:.]/g, '_').replace('T', '_').split('Z')[0];
          const uniqueFileName = `payments_${readableTime}.csv`;
          const link = document.createElement('a');

          link.href = URL.createObjectURL(blob);
          link.download = uniqueFileName;
          link.click();

          URL.revokeObjectURL(link.href);
          this.disableExport = false;
          this.$toast.success('Payments exported successfully!');
      })
      .catch(async (error) => {
        try {
          if (error.response?.status === 422) {
            let errors = {};
            const responseData = error.response.data;

            if (responseData instanceof Blob) {
              const parsed = JSON.parse(await responseData.text());
              errors = parsed?.errors || {};
            } else {
              errors = responseData?.errors || {};
            }

            this.validationErrors = errors;
            Object.values(errors).forEach(msg => {
              this.$toast.error(msg);
            })
          } else {
            this.$toast.error('Failed to export payments. Please try again.');
          }
        } finally {
          this.disableExport = false;
          console.error('Error downloading file:', error);
        }
      })
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    customDate(date) {
      let dateValue = this[date];

      // Check if the input is a valid date
      if (dateValue) {
        // Convert the input to a Date object
        const dateObject = new Date(dateValue);
        this[date] = this.formatDate(dateObject);
      }
    },
    paginate(page) {
      this.currentPage = page;
      this.getPayments();
    },

    getRefundAmount(refundData) {
      const totalRefundCents = refundData.reduce((total, refund) => {
        if (refund.refund_type !== 'payment_refunded') {
          return total;
        }

        return total + Number(refund.amount || 0);
      }, 0);

      return (totalRefundCents / 100).toFixed(2);
    },

    getPaymentStatuses() {
      return axios.get('/admin/payments/get/statuses')
      .then(response => {
        this.paymentStatuses = response.data;
        this.status = this.paymentStatuses['visible']['statuses'];
      });
    },

    getPaymentProviders() {
      axios.get('/admin/payments/get/providers')
      .then(response => {
        this.paymentProviders = response.data;
      });
    }
  }
}
</script>
